import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getSharedMobilityReport } from "../../../../services/mobilityReportApi";
import { getCurrentLocale } from "../../../../utlis/locale";
import AppReportToolbar from "../../../report/AppReportToolbar";
import RenderReportDocument from "./RenderReportDocument";
import { printReport, reportErrorKey, reportText } from "./reportPresentation";
import "./SharedMobilityReportV2.scss";

const SharedMobilityReport = () => {
  const { slug } = useParams();
  const [reload, setReload] = useState(0);
  const [state, setState] = useState({ status: "loading", slug });
  const [printing, setPrinting] = useState(false);
  const [notice, setNotice] = useState("");
  const root = useRef(null);
  const currentSlug = useRef(slug);
  currentSlug.current = slug;
  const printLock = useRef(false);
  useEffect(() => {
    const controller = new AbortController();
    setNotice("");
    setState({ status: "loading", slug });
    getSharedMobilityReport(slug, { signal: controller.signal })
      .then((result) => {
        if (!controller.signal.aborted)
          setState({ ...result, status: "ok", slug });
      })
      .catch((error) => {
        if (!controller.signal.aborted)
          setState({ status: reportErrorKey(error), slug });
      });
    return () => controller.abort();
  }, [slug, reload]);
  const visible = state.slug === slug ? state : { status: "loading" };
  const report = visible.document;
  const locale = report?.context?.content_locale || getCurrentLocale();
  const t = (key) => reportText(locale, key);
  const canPrint =
    report?.capabilities?.can_print === true ||
    report?.capabilities?.can_print?.allowed === true;
  const print = async () => {
    if (printLock.current) return;
    printLock.current = true;
    const key = slug;
    setPrinting(true);
    try {
      await printReport(root.current, () => currentSlug.current === key);
    } catch {
      if (currentSlug.current === key) setNotice(t("print_error"));
    } finally {
      if (currentSlug.current === key) setPrinting(false);
      printLock.current = false;
    }
  };
  return (
    <main
      className="shared-mobility-report mobility-render-route"
      lang={locale}
      ref={root}
    >
      <AppReportToolbar />
      <nav className="mobility-render-toolbar" aria-label={t("report")}>
        <strong>{report?.presentation?.title || t("report")}</strong>
        {canPrint && (
          <button type="button" disabled={printing} onClick={print}>
            {t("print")}
          </button>
        )}
      </nav>
      {notice && <p role="alert">{notice}</p>}
      {report ? (
        <RenderReportDocument report={report} readOnly />
      ) : (
        <section
          className="mobility-report-state"
          role={visible.status === "loading" ? "status" : "alert"}
        >
          <h1>{t(visible.status)}</h1>
          {visible.status !== "loading" && (
            <button
              type="button"
              onClick={() => setReload((value) => value + 1)}
            >
              {t("retry")}
            </button>
          )}
        </section>
      )}
    </main>
  );
};
export default SharedMobilityReport;
